import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fc988280"
import script from "./invoiceApproval.js?vue&type=script&lang=js&external"
export * from "./invoiceApproval.js?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=fc988280&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports